module.exports = __webpack_public_path__ + "static/img/17.5920534.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/17.png
// module id = 3vtP
// module chunks = 0